module.exports = __webpack_public_path__ + "static/media/people-procurement.145c04f4.svg";